import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { bindActionCreators } from "redux";
import { components } from "react-select";
import { Row, Col } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";
import { FaCircle } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { debounce } from "lodash";

import { Link } from "react-router-dom";

import find from "lodash/find";
import orderBy from "lodash/orderBy";
import moment from "moment";
import matchSorter from "match-sorter";
import Timeline, {
  TimelineMarkers,
  TodayMarker,
  CursorMarker,
  TimelineHeaders,
  DateHeader
} from "react-calendar-timeline";
import "react-calendar-timeline/lib/Timeline.css";
import containerResizeDetector from "react-calendar-timeline/lib/resize-detector/container";

import * as callActions from "../../../actions/callActions";
import * as codeActions from "../../../actions/codeActions";
import * as modalActions from "../../../actions/modalActions";
import * as userActions from "../../../actions/userActions";
import * as departmentActions from "../../../actions/departmentActions";
import Legend from "../Legend";
import FiltersComponent from "../../common/FiltersComponent";
import { customToast as toast } from "../../../utils";
import HeaderWrapper from "../../common/HeaderWrapper";
import ConfirmModal from "../../common/ConfirmModal";
import Badge from "../../common/Badge";
import CallService from "../../../services/callService";

import InfoLabel from "./InfoLabel";

import TimePlannerControls from "./TimePlannerControls";

import { hexToRgba } from "@redkeep/utils";

import "./TimePlannerPage.scss";

const keys = {
  groupIdKey: "id",
  groupTitleKey: "title",
  groupRightTitleKey: "rightTitle",
  itemIdKey: "id",
  itemTitleKey: "title",
  itemDivTitleKey: "title",
  itemGroupKey: "group",
  itemTimeStartKey: "arrival_date",
  itemTimeEndKey: "completed_date",
  groupLabelKey: "title"
};

const options = [
  {
    value: "day",
    label: "Day"
  },
  {
    value: "week",
    label: "Week"
  }
];

export const getClassName = (priority) => {
  if (priority === "Low") {
    return "success";
  }
  if (priority === "Normal") {
    return "warning";
  }
  return "danger";
};

const CustomMenuList = (props) => (
  <div style={{ backgroundColor: "blue" }}>
    <components.MenuList {...props}>{props.children}</components.MenuList>
  </div>
);

CustomMenuList.propTypes = {
  children: PropTypes.node
};

const formatDate = (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  return "";
};
class TimePlannerPage extends Component {
  fetchData = debounce(() => {
    this.setState({ loading: true }, async () => {
      try {
        const { filters } = this.state;

        const { arrival_date, completed_date } = filters;

        const query = {
          arrival_date,
          completed_date
        };

        if (filters.department?.length) {
          query.department = filters.department.map((d) => d.value);
        }

        if (filters.assigned_to?.length) {
          query.assigned_to = filters.assigned_to.map((d) => d.value);
        }

        const result = await CallService.fetchTimePlannerCalls({
          ...query
        });

        this.setState({ calls: result, loading: false, initialLoading: false });
      } catch ({ response }) {
        if (response.data.errors) {
          toast.error(response.data.errors.message);
        }
      }
    });
  }, 500);

  constructor(props) {
    super(props);

    this.state = {
      calls: [],
      resources: [],
      blocks: [],
      search: "",
      selected: [],
      draggedItem: undefined,
      view: { value: "day", label: "Day" },
      loading: true,
      initialLoading: true,
      selectedDate: formatDate(new Date()),
      filters: {
        arrival_date: moment().startOf("day").add(6, "hours").valueOf(),
        completed_date: moment().endOf("day").subtract(3, "hours").valueOf(),
        department: [
          {
            value: props.auth.user.department._id,
            label: props.auth.user.department.description
          }
        ]
      }
    };
    this.openTipRefs = {};
  }

  componentDidMount = async () => {
    const { departments, actions, users, codes } = this.props;

    if (!users.length) await actions.loadUsers({ is_active: true });
    if (!departments.length) await actions.loadDepartments();
    if (!codes.length) await actions.loadCodes();

    this.fetchData();
  };

  // shouldComponentUpdate = (nextProps, nextState) =>
  //   nextState !== this.state || nextProps.modal !== this.props.modal;

  onItemMove = (itemId, dragTime, newGroupOrder) => {
    const call = find(this.state.calls, { _id: itemId });

    if (call.stage.order <= 4) {
      if (call.recurring_id) {
        this.setState({ itemId, dragTime, newGroupOrder });
        this.props.actions.requestCallId(call._id);
      } else {
        this.handleItemMove(itemId, dragTime, newGroupOrder);
      }
    }
  };

  onItemResize = (itemId, dragTime, newGroupOrder) => {
    const call = find(this.state.calls, { _id: itemId });

    if (call?.stage.order <= 4) {
      if (call.recurring_id) {
        this.setState({ itemId, dragTime, newGroupOrder });
        this.props.actions.requestCallId(call._id);
      }
      this.handleItemResize(itemId, dragTime, newGroupOrder);
    }
  };

  onItemSelect = (itemId) => {
    const { calls } = this.state;

    const currIndex = calls.findIndex((b) => b.id === itemId);
    if (currIndex !== -1) {
      const call = calls[currIndex];
      if (call.stage?.order < 4) {
        this.setState({
          selected: [itemId]
        });
      }
    }
  };

  onItemDeselect = () => {
    this.setState({ selected: [] });
  };

  onTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    const {
      filters: { arrival_date: defaultTimeStart }
    } = this.state;

    const minZoom = 1000 * 60 * 60; // 1 hours
    const maxZoom = 1000 * 60 * 60 * 24 * 7; // 1 weeks

    const currentZoom = visibleTimeEnd - visibleTimeStart;

    if (currentZoom > maxZoom) {
      this.timeline.updateScrollCanvas(
        defaultTimeStart,
        defaultTimeStart + maxZoom
      );
    } else if (currentZoom < minZoom) {
      this.timeline.updateScrollCanvas(
        defaultTimeStart,
        defaultTimeStart + minZoom
      );
    } else {
      this.setState(
        {
          defaultTimeStart: visibleTimeStart,
          defaultTimeEnd: visibleTimeEnd
        },
        () => {
          updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
        }
      );
    }
  };

  onClickFilter = (user) => () => {
    this.handleChangeFilters("assigned_to", [
      {
        value: user.id,
        label: user.full_name
      }
    ]);
  };

  onZoom = () => {
    this.setState({ selected: [] });
  };

  getBgColor = (item, itemContext) => {
    if (itemContext.dragging) {
      return "#808080";
    }
    if (itemContext.selected) {
      return "#808080";
    }
    return item.bgColor;
  };

  getGroups = () => {
    const { users } = this.props;

    const { filters } = this.state;

    const groups = orderBy(
      users.map((user) => ({
        id: user.id,
        full_name: `${user.full_name}`,
        avatar: user.avatar,
        department: user.department.description
      })),
      "full_name"
    ).filter(
      (g) =>
        !filters.department?.length ||
        filters.department.find((d) => d.label === g.department)
    );

    return groups;
  };

  getItems = () => {
    const { calls } = this.state;
    const result = calls.map((call) => {
      const completed = [
        moment(call.arrival_date).add(30, "minutes").valueOf()
      ];
      if (call.completed_date) {
        completed.push(moment(call.completed_date).valueOf());
      }
      if (call.arrival_date && call.actual_hrs) {
        completed.push(
          moment(call.arrival_date).add(call.actual_hrs, "hours").valueOf()
        );
      }
      const completedDate = Math.max(...completed);
      let color = call.stage?.color;

      // personal calls
      const callType = this.props.codes.find(
        (code) => code._id === call.call_type
      );

      // onsite calls
      const workplace = this.props.codes.find(
        (code) => code._id === call.workplace
      );
      if (workplace?.value === "ONSITE" && call.stage?.order <= 3) {
        color = "#0066ff";
      }
      if (callType?.value === "PERSONAL") {
        color = "#993333";
      }

      let className = "";
      let priority = null;

      if (call.priority) {
        priority = this.props.codes.find((code) => code._id === call.priority);
        className = priority?.label ? getClassName(priority.label) : "";
      }

      return {
        id: call._id,
        group: call.assigned_to,
        title:
          call.customer && call.project
            ? `${call.customer.name} - ${call.project.name}`
            : "",
        arrival_date: moment(call.arrival_date).valueOf(),
        completed_date: completedDate,
        tipData:
          call.customer?.name && call.project?.name && call.internal_notes
            ? `<p>${call.customer.name} - ${call.project.name}<br/>${call.internal_notes}</p>`
            : "Customer, Project, or Internal Notes are missing.",
        selectedBgColor: call.stage
          ? hexToRgba(call.stage.color, 0.2)
          : "black",
        bgColor: color,
        canResize: call.stage?.order < 4,
        canMove: call.stage?.order < 4,
        priorityLabel: priority?.label || null,
        className,
        customerName: call.customer?.name || "Customer missing",
        projectName: call.project?.name || "Project missing",
        internalNotes: call.internal_notes || ""
      };
    });

    return result;
  };

  handleItemResize = (itemId, time, edge) => {
    const { calls } = this.state;

    const currCalls = [...calls];
    const currIndex = currCalls.findIndex((b) => b.id === itemId);

    if (currIndex !== -1) {
      const call = currCalls[currIndex];

      const updatedCall = {
        ...call,
        arrival_date: edge === "left" ? moment(time) : call.arrival_date,
        completed_date: edge === "right" ? moment(time) : call.completed_date
      };

      // set hours if call isn't reserved
      if (call.stage.order >= 4) {
        const duration = moment.duration(
          moment(updatedCall.completed_date).diff(
            moment(updatedCall.arrival_date)
          )
        );
        const hours = duration.asHours().toFixed(2);
        updatedCall.actual_hrs = hours;
      }

      this.props.actions.updateCall(updatedCall);

      currCalls.splice(currIndex, 1, updatedCall);

      this.setState({ calls: currCalls, draggedItem: undefined });
    }
  };

  handleItemDoubleClick = (itemId) => {
    this.props.history.push(
      `/app/calls/${itemId}?ref=${window.location.pathname}`
    );
  };

  itemRenderer = ({ item, itemContext, getItemProps, getResizeProps }) => {
    const backgroundColor = this.getBgColor(item, itemContext);
    const { left: leftResizeProps, right: rightResizeProps } = getResizeProps({
      leftStyle: {
        cursor: item.canResize ? "ew-resize" : "not-allowed",
        backgroundColor: "rgba(0,0,0,0.1)",
        width: 10,
        zIndex: 99999999999
      },
      rightStyle: {
        cursor: item.canResize ? "ew-resize" : "not-allowed",
        backgroundColor: "rgba(0,0,0,0.1)",
        width: 10,
        zIndex: 99999999999
      }
    });
    const itemProps = getItemProps({
      className: "timeplanner-item",
      style: {
        backgroundColor,
        border: "none",
        borderRadius: 4,
        overflow: "hidden",
        paddingLeft: 5,
        paddingRight: 5,
        lineHeight: 1,
        cursor: item.canResize || item.canMove ? "pointer" : "not-allowed"
      }
    });

    return (
      <React.Fragment>
        <div {...itemProps} title="">
          {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : ""}

          <div
            className="rct-item-content"
            ref={(ref) =>
              (this.openTipRefs = { ...this.openTipRefs, [item.id]: ref })
            }
            id={item.id}
            data-tooltip-variant={
              this.props.auth.isNightMode ? "dark" : "light"
            }
          >
            <div>
              {item.priorityLabel ? (
                <FaCircle
                  size={16}
                  className={`ticketIcon ${item.className}`}
                />
              ) : null}
              <span>{itemContext.title}</span>
            </div>
          </div>

          {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : ""}
        </div>
        <ReactTooltip
          anchorId={item.id}
          effect="solid"
          place="top"
          className={`custom-tooltip ${
            this.props.auth.isNightMode ? "dark" : "light"
          }`}
          globalEventOff="click"
        >
          {" "}
          {item.priorityLabel ? (
            <div style={{ textAlign: "center" }}>
              <Badge className={`fixed-width ${item.className}`}>
                {item.priorityLabel}
              </Badge>
            </div>
          ) : null}
          <span>
            <p>
              {item.customerName} - {item.projectName}
              <br />
              {item.internalNotes}
            </p>
          </span>
        </ReactTooltip>
      </React.Fragment>
    );
  };

  handleAdd = () => {
    this.props.history.push("/app/calls/add?ref=/app/time-planner");
  };

  /* Fetch more calls based on time in view */
  handleBoundsChange = (canvasTimeStart, canvasTimeEnd) => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          arrival_date: canvasTimeStart,
          completed_date: canvasTimeEnd
        }
      },
      () => this.fetchData()
    );
  };

  handleItemMove = (itemId, dragTime, newGroupOrder) => {
    const { calls } = this.state;
    const { departments } = this.props;
    const groups = this.getGroups();
    const group = groups[newGroupOrder];

    const currCalls = [...calls];

    const currIndex = currCalls.findIndex((b) => b.id === itemId);

    if (currIndex !== -1) {
      const call = currCalls[currIndex];

      const department = find(departments, {
        description: group.department
      });

      const completedDate = call.completed_date
        ? moment(
            dragTime +
              (moment(call.completed_date).valueOf() -
                moment(call.arrival_date).valueOf())
          ).toDate()
        : moment(
            dragTime +
              (moment(call.arrival_date)
                .add(call.actual_hrs, "hours")
                .valueOf() -
                moment(call.arrival_date).valueOf())
          ).toDate();

      const updatedCall = {
        ...call,
        department: department._id,
        recurring_id: null,
        arrival_date: moment(dragTime).toDate(),
        completed_date: completedDate,
        assigned_to: group.id
      };

      this.props.actions.updateCall(updatedCall);

      currCalls.splice(currIndex, 1, updatedCall);

      this.setState({ calls: currCalls, draggedItem: undefined });
    }
  };

  groupRenderer = ({ group }) => (
    <Link to={`/app/settings/users/${group.id}`} className="custom-group">
      <span className="title">{group.full_name}</span>
    </Link>
  );

  handleChangeFilters = (field, input) => {
    const filters = { ...this.state.filters };

    filters[field] = input;
    this.setState({ filters }, () => {
      this.fetchData();
      if (filters.assigned_to && filters.assigned_to.length) {
        this.setState({
          resources: orderBy(
            this.props.users
              .filter((user) =>
                this.state.filters.assigned_to.find(
                  (assigned_to) => assigned_to.value === user._id
                )
              )
              .map((user) => ({
                id: user.id,
                full_name: `${user.full_name}`,
                avatar: user.avatar,
                department: user.department.description
              })),
            "full_name"
          )
        });
      } else if (filters.department && filters.department.length) {
        this.setState({
          resources: orderBy(
            this.props.users
              .filter((user) =>
                this.state.filters.department.find(
                  (department) => department.value === user.department.id
                )
              )
              .map((user) => ({
                id: user.id,
                full_name: `${user.full_name}`,
                avatar: user.avatar,
                department: user.department.description
              })),
            "full_name"
          )
        });
      } else {
        this.setState({
          resources: orderBy(
            this.props.users.map((user) => ({
              id: user.id,
              full_name: `${user.full_name}`,
              avatar: user.avatar,
              department: user.department.description
            })),
            "full_name"
          )
        });
      }
    });
  };

  resetFilters = () => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          assigned_to: [],
          department: []
        },
        search: "",
        resources: orderBy(
          this.props.users.map((user) => ({
            id: user.id,
            full_name: `${user.full_name}`,
            avatar: user.avatar,
            department: user.department.description
          })),
          "full_name"
        )
      },
      () => this.fetchData()
    );
  };

  filterResources = (e) => {
    const { value } = e.target;

    const resources = [];
    this.props.users.map((user) =>
      resources.push({
        id: user.id,
        full_name: `${user.full_name}`,
        avatar: user.avatar
      })
    );

    let filteredResources = matchSorter(resources, value, {
      keys: ["full_name"]
    });

    filteredResources = orderBy(filteredResources, "full_name");

    this.setState({
      resources: filteredResources,
      search: value
    });
  };

  toggleView = (view) => {
    const {
      filters: { arrival_date, completed_date }
    } = this.state;

    const center =
      moment(arrival_date).valueOf() +
      (moment(completed_date).valueOf() - moment(arrival_date).valueOf()) / 2;

    const start = moment(center).startOf(view.value);
    const end = moment(center).endOf(view.value);

    this.setState(
      {
        view,
        defaultTimeStart: start,
        defaultTimeEnd: end,
        filters: {
          ...this.state.filters,
          arrival_date: start,
          completed_date: end
        }
      },
      () => this.timeline.updateScrollCanvas(start, end)
    );
  };

  clearView = () => {
    this.setState({ view: {} });
  };

  animateScroll = (invert) => {
    const width = (invert ? -1 : 1) * parseFloat(this.scrollRef.style.width);
    const duration = 700;

    const startTime = performance.now();

    let lastWidth = 0;
    const animate = () => {
      let normalizedTime = (performance.now() - startTime) / duration;
      if (normalizedTime > 1) {
        normalizedTime = 1;
      }
      const calculatedWidth = Math.floor(
        width * 0.5 * (1 + Math.cos(Math.PI * (normalizedTime - 1)))
      );
      this.scrollRef.scrollLeft += calculatedWidth - lastWidth;
      lastWidth = calculatedWidth;

      if (normalizedTime < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  };

  handleManualScroll = (isLeft) => () => {
    this.animateScroll(isLeft);
  };

  goToToday = () => {
    const today = moment().startOf("day");
    const visibleTimeStart = moment(today).add(6, "hours").valueOf();
    const visibleTimeEnd = moment(today)
      .endOf("day")
      .subtract(3, "hours")
      .valueOf();

    this.timeline.updateScrollCanvas(visibleTimeStart, visibleTimeEnd);

    const dateStr = formatDate(today.toDate());
    this.setState({
      view: { label: "Day", value: "day" },
      selectedDate: dateStr
    });
  };

  handleItemDrag = ({ itemId, time, newGroupOrder }) => {
    let item = this.state.draggedItem ? this.state.draggedItem.item : undefined;
    if (!item) {
      item = this.state.items.find((i) => i.id === itemId);
    }
    this.setState({
      draggedItem: { item, group: this.state.groups[newGroupOrder], time }
    });
  };

  handleNext = () => {
    const { view } = this.state;
    const { visibleTimeStart, visibleTimeEnd } = this.timeline.state;

    const start = moment(visibleTimeStart).add(1, view.value);
    const end = moment(visibleTimeEnd).add(1, view.value);

    this.timeline.updateScrollCanvas(start, end);
  };

  handlePrev = () => {
    const { view } = this.state;

    const { visibleTimeStart, visibleTimeEnd } = this.timeline.state;

    const start = moment(visibleTimeStart).subtract(1, view.value);
    const end = moment(visibleTimeEnd).subtract(1, view.value);

    this.timeline.updateScrollCanvas(start, end);
  };

  handleChangeDate = (e) => {
    const { view } = this.state;

    const { value } = e.currentTarget;

    if (value) {
      const day = moment(value);
      if (view.value === "day") {
        const start = moment(day).startOf(view.value).add(6, "hours").valueOf();

        const end = moment(day)
          .endOf(view.value)
          .subtract(3, "hours")
          .valueOf();

        this.timeline.updateScrollCanvas(start, end);
      } else {
        const start = moment(day).startOf(view.value).valueOf();

        const end = moment(day).endOf(view.value).valueOf();

        this.timeline.updateScrollCanvas(start, end);
      }
    }
    this.setState({ selectedDate: value });
  };

  isSomeEmpty = (...args) =>
    args.some((arg) => Array.isArray(arg) && arg.length === 0);

  handleZoomOut = () => {
    this.timeline.changeZoom(1.5);
  };

  handleZoomIn = () => {
    this.timeline.changeZoom(0.5);
  };

  render() {
    const { codes, auth } = this.props;
    const {
      open,
      filters,
      view,
      draggedItem,
      selected,
      loading,
      selectedDate,
      initialLoading
    } = this.state;

    const items = this.getItems();
    const groups = this.getGroups();

    const minZoom = 1000 * 60 * 60; // 1 hours
    const maxZoom = 1000 * 60 * 60 * 24 * 7; // 1 weeks
    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: "Time Planner" }]}
          onClickAdd={this.handleAdd}
          onClickAction={[
            {
              action: () => this.setState({ open: !open }),
              icon: <IoFunnel />
            }
          ]}
        />

        <Row>
          <Col md={12}>
            <FiltersComponent
              open={open}
              filters={filters}
              onChangeFilters={this.handleChangeFilters}
              onReset={this.resetFilters}
              fields={["Department", "Assigned To"]}
            />
          </Col>
        </Row>

        <div
          className={`content-wrapper mt-0 time-planner-page ${
            auth.isNightMode ? "is-night-mode" : ""
          }`}
        >
          <TimePlannerControls
            selectedDate={selectedDate}
            selected={selected}
            view={view}
            options={options}
            auth={auth}
            loading={loading}
            goToToday={this.goToToday}
            handleChangeDate={this.handleChangeDate}
            toggleView={this.toggleView}
            handleNext={this.handleNext}
            handlePrev={this.handlePrev}
            handleZoomIn={this.handleZoomIn}
            handleZoomOut={this.handleZoomOut}
          />
          <div className="scroll-container">
            {!initialLoading && (
              <Timeline
                resizeDetector={containerResizeDetector}
                ref={(el) => (this.timeline = el)}
                scrollRef={(el) => (this.scrollRef = el)}
                keys={keys}
                groups={groups}
                items={items}
                itemTouchSendsClick={false}
                stackItems
                itemHeightRatio={0.75}
                showCursorLine
                defaultTimeStart={moment().startOf("day").add(6, "hour")}
                defaultTimeEnd={moment().endOf("day").subtract(3, "hour")}
                minZoom={minZoom}
                maxZoom={maxZoom}
                // fixedHeader="fixed"
                selected={selected}
                timeSteps={{
                  second: 1,
                  minute: 15,
                  hour: 1,
                  day: 1,
                  month: 1,
                  year: 1
                }}
                useResizeHandle
                // renderers
                groupRenderer={this.groupRenderer}
                itemRenderer={this.itemRenderer}
                // listeners
                onItemMove={this.onItemMove}
                onItemResize={this.onItemResize}
                onBoundsChange={this.handleBoundsChange}
                // limit 1000 and 2000 level users
                onItemSelect={auth.maxRole > 2000 && this.onItemSelect}
                onItemDeselect={this.onItemDeselect}
                onTimeChange={this.onTimeChange}
                onItemDoubleClick={this.handleItemDoubleClick}
                onZoom={this.onZoom}
              >
                <TimelineHeaders>
                  <DateHeader unit="primaryHeader" />
                  <DateHeader />
                </TimelineHeaders>
                <TimelineMarkers>
                  <TodayMarker>
                    {({ styles }) => (
                      <div style={{ ...styles, background: "#424874" }} />
                    )}
                  </TodayMarker>
                  <CursorMarker>
                    {({ styles }) => (
                      <div style={{ ...styles, background: "#ffcd3f" }} />
                    )}
                  </CursorMarker>
                </TimelineMarkers>
              </Timeline>
            )}
          </div>
          {draggedItem && (
            <InfoLabel
              item={this.state.draggedItem.item}
              group={this.state.draggedItem.group}
              time={this.state.draggedItem.time}
            />
          )}
          <div style={{ border: "2px solid black", marginTop: "10px" }}>
            <Legend codes={codes} type="unavailable" />
            <Legend codes={codes} type="call statuses" />
          </div>
        </div>
        <ConfirmModal
          id="callConfirmModal"
          title="This call is part of a recurring series."
          body="Are you sure you want to edit this call?"
          close={this.props.actions.hideModal}
          confirm={() =>
            this.handleItemMove(
              this.state.itemId,
              this.state.dragTime,
              this.state.newGroupOrder
            )
          }
        />
      </React.Fragment>
    );
  }
}

TimePlannerPage.propTypes = {
  actions: PropTypes.object.isRequired,
  codes: PropTypes.array,
  users: PropTypes.array,
  auth: PropTypes.object,
  departments: PropTypes.array,
  params: PropTypes.object,
  modal: PropTypes.object,
  history: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    codes: state.reducers.codes,
    departments: state.reducers.departments,
    users: state.reducers.users,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...callActions,
        ...modalActions,
        ...codeActions,
        ...userActions,
        ...departmentActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(TimePlannerPage);
